import * as React from 'react';

import { Button } from '@origin-digital/ods-core';
interface Props {
  onClick?: (e?: any) => void | boolean;
  href?: string;
  children: React.ReactNode;
}

export const ButtonAction: React.FunctionComponent<Props> = ({ href, onClick, children }) => {
  return (
    <Button href={href} onClick={onClick}>
      {children}
    </Button>
  );
};
